import { ActionType } from "../../model/enum/ActionType";
import { ActionResponseValue, PhotoActionResponse } from "../../model/actions/ActionResponse";

export const isPhotoAction = (candidate?: ActionResponseValue): candidate is PhotoActionResponse => {
  return !!candidate && candidate.type === ActionType.Photo && "content" in candidate;
};
